import React, { useEffect, useState } from "react";
import { IconButton, Alert, Snackbar } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import "./RequestedChanges.css";

const RequestedChanges = (props) => {
  const [requests, setRequests] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const email = props.Employee.email;
  const user = props.user ? props.user : null;

  const fetchRequests = async () => {
    try {
      const response = await fetch(
        `https://hr-backend-72v1.onrender.com/getRequestedChanges/${email}`
      );
      const data = await response.json();
      if (data.success) {
        setRequests(data.requests.reverse());
      } else {
        console.error("Error fetching requested changes");
      }
    } catch (error) {
      console.error("Error fetching requested changes:");
    }
  };
  useEffect(() => {
    fetchRequests();
  }, []);

  // Approve a request
  const approveRequest = async (request) => {
    try {
      const response = await fetch("https://hr-backend-72v1.onrender.com/approveRequest", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: request._id }),
      });
      const data = await response.json();
      if (data.success) {
        setAlertMessage("Request accepted");
        setShowAlert(true);
        fetchRequests(); // Refresh the table after approval
      } else {
        alert("Error approving request");
      }
    } catch (error) {
      console.error("Error approving request:");
    }
  };

  // Reject a request (delete)
  const rejectRequest = async (id) => {
    try {
      const response = await fetch(
        `https://hr-backend-72v1.onrender.com/rejectRequest/${id}`,
        {
          method: "DELETE",
        }
      );
      const data = await response.json();
      if (data.success) {
        setAlertMessage("Request rejected");
        setShowAlert(true);
        fetchRequests(); // Refresh the table after rejection
      } else {
        alert("Error rejecting request");
      }
    } catch (error) {
      console.error("Error rejecting request:");
    }
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const showActions = user && (user.role === "HR" || user.role === "Executive");
  const approvedCount = requests.filter((r) => r.status !== "pending").length;
  const cols = showActions
    ? "190px minmax(160px, 1fr) 150px 120px"
    : "190px minmax(160px, 1fr) 150px";

  return (
    <div className="rcWrap">
      <header className="rcHeader">
        <div>
          <h1 className="rcTitle">Requested Changes</h1>
          <p className="rcSubtitle">Profile edits submitted for approval</p>
        </div>
        <span className="rcApprovedPill">
          <CheckIcon sx={{ fontSize: 15 }} />
          {approvedCount} approved
        </span>
      </header>

      <section className="rcCard">
        <div className="rcRow rcRow--head" style={{ gridTemplateColumns: cols }}>
          <span>Field</span>
          <span>Requested Change</span>
          <span className="rcRight">Status</span>
          {showActions && <span className="rcRight">Actions</span>}
        </div>

        {requests.length === 0 ? (
          <div className="rcEmpty">
            <span className="rcEmptyIcon">
              <EditNoteOutlinedIcon sx={{ fontSize: 26 }} />
            </span>
            <div>
              <div className="rcEmptyTitle">No requested changes yet</div>
              <div className="rcEmptySub">
                Profile edits submitted for approval will appear here.
              </div>
            </div>
          </div>
        ) : (
          requests.map((request) => {
            const isPending = request.status === "pending";
            return (
              <div
                className="rcRow"
                key={request._id}
                style={{ gridTemplateColumns: cols }}
              >
                <span className="rcFieldChip">{request.field}</span>
                <span className="rcValue">{request.value}</span>
                <span className="rcRight">
                  <span
                    className={`rcPill ${isPending ? "rcPill--pending" : "rcPill--approved"}`}
                  >
                    {isPending ? "Pending" : "Approved"}
                  </span>
                </span>
                {showActions && (
                  <span className="rcRight">
                    {isPending ? (
                      <span className="rcActions">
                        <IconButton
                          color="success"
                          size="small"
                          onClick={() => approveRequest(request)}
                        >
                          <DoneIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          size="small"
                          onClick={() => rejectRequest(request._id)}
                        >
                          <CloseIcon />
                        </IconButton>
                      </span>
                    ) : (
                      <span className="rcTaken">Already Taken</span>
                    )}
                  </span>
                )}
              </div>
            );
          })
        )}
      </section>

      <Snackbar
        open={showAlert}
        autoHideDuration={5000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseAlert}
          severity={alertMessage.includes("accepted") ? "success" : "error"}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default RequestedChanges;
